import { plog } from '../utils/plog';

const PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID ?? process.env.FBASE_PROJECT_ID;
const FUNCTIONS_URL = process.env.REACT_APP_FIREBASE_FUNCTIONS ?? process.env.FBASE_FUNCTIONS;
const DEPLOYED_REGION = 'northamerica-northeast1';
const CLOUD_URL = 'cloudfunctions.net';
const LOCAL_URL = `http://${FUNCTIONS_URL}/${PROJECT_ID}/${DEPLOYED_REGION}`;
const REMOTE_URL = `https://${DEPLOYED_REGION}-${PROJECT_ID}.${CLOUD_URL}`;

const API_BASE_URL = process.env.NODE_ENV === 'development' || !process.env.NODE_ENV ? LOCAL_URL : REMOTE_URL;
plog('Client API base URL: ', API_BASE_URL);

export default API_BASE_URL;
